<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <div id="workflow-process_execution" class="content">
                <em-workflow-process-execution :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey" :businessKey="$_emWorkflowTaskMixin_businessKey">
                </em-workflow-process-execution>
            </div>

            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <em-workflow-task-complete :taskId="$_emWorkflowTaskMixin_taskId" :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                           @taskCompleted="$_emWorkflowTaskMixin_handleTaskCompleted">
                </em-workflow-task-complete>
            </div>
        </section>
    </div>
</template>
<script>
    // Author Shi Wenlong
// Date 2021-05-31 17:05:47

    import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete";
import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine";

    export default {
        name: "sithMesQualityToolBorrowRecordWorkflowTaskView",
  components: {WorkflowProcessLine, WorkflowTaskComplete},
  mixins: [emWorkflowTaskMixin, workflowTaskMixins],
        computed: {
            modelName() {
                return this.$_emRouterHelperMixin_entityName
            }
        }
    };
</script>